import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme: Theme) => {
  return {
    header: {
      background: theme.palette.KenColors.kenWhite,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'start',
      justifyContent: 'center',
      height: '10vh !important',
      paddingInline: '20px',
      textAlign: 'start',
      fontFamily: 'GeneralSans',
      boxShadow: 'none !important',
      marginBottom: '10px',
      [theme.breakpoints.down('md')]: {
        height: '60px !important',
      },
    },

nav: {
  background: theme.palette.KenColors.kenWhite,
  width: '100%',
  borderRadius: '9px !important',
  boxShadow: 'none !important',
  padding: '15px 0px',
  display: 'flex',
  flexDirection: 'column',
  height: '77vh',
  position: 'relative',
  maxHeight: '100vh',                  
},


    actions: {
      background: theme.palette.KenColors.kenWhite,
      display: 'flex',
      height: '10vh',
      justifyContent: 'space-around',
      paddingInline: '10px',
      alignItems: 'center',
      borderRadius: '9px !important',
      boxShadow: 'none !important',
      [theme.breakpoints.down('md')]: {
        paddingInline: '5px',
      },
    },

    actionLogo: {
      height: '60.36px',
      objectFit: 'cover',
      borderRadius: '30px !important',

      '@media (min-width: 1280px) and (max-width: 1300px)': {
        height: '35px',
      },
    },

    actionText: {
      whiteSpace: 'wrap',
      fontSize: '12px',
      fontWeight: '500 !important',
      color: theme.palette.KenColors.ClientBlack,
    },

    profilImage: {
      height: '90px',
      width: '90px',
      borderRadius: '50px',
      objectFit: 'cover',
      marginBottom: '20px',
    },

    profileName: {
      fontSize: '15px !important',
      fontWeight: '600 !important',
      color: theme.palette.KenColors.ClientBlack2,
      '@media (min-width: 1280px) and (max-width: 1300px)': {
        fontSize: '11px !important',
      },
    },

    profileDesignation: {
      fontSize: '12px !important',
      fontWeight: '400 !important',
      color: theme.palette.KenColors.ClientBlack2,
      '@media (min-width: 1280px) and (max-width: 1300px)': {
        fontSize: '9px !important',
      },
    },

    /* ------------------ MENU LIST BUTTONS ------------------ */
    listItemButton: {
      borderRadius: '10px 0px 0px 10px !important',
      marginLeft: '10px !important',
      '&:hover': {
        backgroundColor: '#2C60AA !important',
        '& $listItemText, & $listItemIcon': {
          color: '#FFFFFF !important',
        },
      },

      [theme.breakpoints.down('md')]: {
        marginLeft: '2px !important',
      },
    },

    listItemButtonActive: {
      backgroundColor: '#2C60AA !important',
      '& $listItemText, & $listItemIcon': {
        color: '#FFFFFF !important',
      },
    },

    /* ------------------ ICON COLORS ------------------ */

    // Desktop inactive = grey
    // Mobile inactive = blue (#2C60AA)
    listItemIcon: {
      color: "#B2B3B7 !important",

      '@media (min-width: 1280px) and (max-width: 1300px)': {
        fontSize: '15px !important',
      },

      [theme.breakpoints.down('md')]: {
        color: '#2C60AA !important',  // mobile inactive
      },
    },

    // Desktop active = white
    // Mobile active = white (keep same)
    listItemIconActive: {
      color: '#FFFFFF !important',
      fontWeight: '600',

      '@media (min-width: 1280px) and (max-width: 1300px)': {
        fontSize: '15px !important',
      },
    },

    /* ------------------ TEXT COLORS ------------------ */
    listItemText: {
      color: `${theme.palette.KenColors.ClientBlack2} !important`,
      fontSize: '12px !important',
      fontWeight: '400 !important',

      '@media (min-width: 1280px) and (max-width: 1300px)': {
        fontSize: '10px !important',
      },

      '@media (min-width: 1536px) and (max-width: 1636px)': {
        fontSize: '11px !important',
      },
    },

    listItemTextActive: {
      color: '#FFFFFF !important',
      fontSize: '12px !important',
      fontWeight: '600 !important',

      '@media (min-width: 1280px) and (max-width: 1300px)': {
        fontSize: '10px !important',
      },
    },

    listItemTextActive1: {
      color: `#5B4200 !important`,
      fontSize: '12px !important',
      fontWeight: '600 !important',

      '@media (min-width: 1280px) and (max-width: 1300px)': {
        fontSize: '10px !important',
      },
    },

    profilImageMobileView: {
      height: '90px',
      width: '90px',
      borderRadius: '50px',
      objectFit: 'cover',
    },
  };
});

